import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=c72320c8&scoped=true"
import script from "./Google.vue?vue&type=script&lang=js"
export * from "./Google.vue?vue&type=script&lang=js"
import style0 from "./Google.vue?vue&type=style&index=0&id=c72320c8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72320c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c72320c8')) {
      api.createRecord('c72320c8', component.options)
    } else {
      api.reload('c72320c8', component.options)
    }
    module.hot.accept("./Google.vue?vue&type=template&id=c72320c8&scoped=true", function () {
      api.rerender('c72320c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/oauthFPX/social/Google.vue"
export default component.exports